function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Sprite } from "./Sprite";
import { populateString } from "../util/PopulateString";
import * as $array from "../util/Array";
import { Disposer } from "../util/Disposer";
/**
 * @ignore Text is an internal class. Use Label instead.
 */
export var Text = /*#__PURE__*/function (_Sprite) {
  _inherits(Text, _Sprite);
  var _super = _createSuper(Text);
  function Text() {
    var _this;
    _classCallCheck(this, Text);
    _this = _super.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "textStyle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._root._renderer.makeTextStyle()
    });
    Object.defineProperty(_assertThisInitialized(_this), "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._root._renderer.makeText("", _this.textStyle)
    });
    Object.defineProperty(_assertThisInitialized(_this), "_textStyles", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: ["textAlign", "fontFamily", "fontSize", "fontStyle", "fontWeight", "fontStyle", "fontVariant", "textDecoration", "shadowColor", "shadowBlur", "shadowOffsetX", "shadowOffsetY", "shadowOpacity",
      // "leading",
      // "letterSpacing",
      "lineHeight", "baselineRatio",
      //"padding",
      // "stroke",
      // "strokeThickness",
      // "trim",
      // "wordWrap",
      "direction", "textBaseline", "oversizedBehavior", "breakWords", "ellipsis", "minScale"]
    });
    Object.defineProperty(_assertThisInitialized(_this), "_originalScale", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this;
  }
  _createClass(Text, [{
    key: "_updateBounds",
    value: function _updateBounds() {
      if (!this.get("text")) {
        var newBounds = {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        };
        this._adjustedLocalBounds = newBounds;
      } else {
        _get(_getPrototypeOf(Text.prototype), "_updateBounds", this).call(this);
      }
    }
  }, {
    key: "_changed",
    value: function _changed() {
      var _this2 = this;
      _get(_getPrototypeOf(Text.prototype), "_changed", this).call(this);
      this._display.clear();
      var textStyle = this.textStyle;
      if (this.isDirty("opacity")) {
        var opacity = this.get("opacity", 1);
        this._display.alpha = opacity;
      }
      if (this.isDirty("text") || this.isDirty("populateText")) {
        this._display.text = this._getText();
        this.markDirtyBounds();
        if (this.get("role") == "tooltip") {
          this._root.updateTooltip(this);
        }
      }
      if (this.isPrivateDirty("tooltipElement")) {
        var tooltipElement = this.getPrivate("tooltipElement");
        if (tooltipElement) {
          this._disposers.push(new Disposer(function () {
            _this2._root._removeTooltipElement(_this2);
          }));
        }
      }
      if (this.isDirty("width")) {
        textStyle.wordWrapWidth = this.width();
        this.markDirtyBounds();
      }
      if (this.isDirty("oversizedBehavior")) {
        textStyle.oversizedBehavior = this.get("oversizedBehavior", "none");
        this.markDirtyBounds();
      }
      if (this.isDirty("breakWords")) {
        textStyle.breakWords = this.get("breakWords", false);
        this.markDirtyBounds();
      }
      if (this.isDirty("ellipsis")) {
        textStyle.ellipsis = this.get("ellipsis");
        this.markDirtyBounds();
      }
      if (this.isDirty("ignoreFormatting")) {
        textStyle.ignoreFormatting = this.get("ignoreFormatting", false);
        this.markDirtyBounds();
      }
      if (this.isDirty("minScale")) {
        textStyle.minScale = this.get("minScale", 0);
        this.markDirtyBounds();
      }
      if (this.isDirty("fill")) {
        var fill = this.get("fill");
        if (fill) {
          textStyle.fill = fill;
        }
      }
      if (this.isDirty("fillOpacity")) {
        var fillOpacity = this.get("fillOpacity", 1);
        if (fillOpacity) {
          textStyle.fillOpacity = fillOpacity;
        }
      }
      if (this.isDirty("maxWidth") || this.isPrivateDirty("maxWidth")) {
        textStyle.maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
        this.markDirtyBounds();
      }
      if (this.isDirty("maxHeight") || this.isPrivateDirty("maxHeight")) {
        textStyle.maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
        this.markDirtyBounds();
      }
      $array.each(this._textStyles, function (styleName) {
        if (_this2._dirty[styleName]) {
          textStyle[styleName] = _this2.get(styleName);
          _this2.markDirtyBounds();
        }
      });
      textStyle["fontSize"] = this.get("fontSize");
      textStyle["fontFamily"] = this.get("fontFamily");
      this._display.style = textStyle;
      if (this.isDirty("role") && this.get("role") == "tooltip") {
        this._root.updateTooltip(this);
      }
    }
  }, {
    key: "_getText",
    value: function _getText() {
      var text = this.get("text", "");
      return this.get("populateText") ? populateString(this, text) : text;
    }
  }, {
    key: "markDirtyText",
    value: function markDirtyText() {
      this._display.text = this._getText();
      if (this.get("role") == "tooltip") {
        this._root.updateTooltip(this);
      }
      this.markDirtyBounds();
      this.markDirty();
    }
  }, {
    key: "_setDataItem",
    value: function _setDataItem(dataItem) {
      _get(_getPrototypeOf(Text.prototype), "_setDataItem", this).call(this, dataItem);
      if (this.get("populateText")) {
        this.markDirtyText();
      }
    }
  }, {
    key: "getNumberFormatter",
    value: function getNumberFormatter() {
      if (this.parent) {
        return this.parent.getNumberFormatter();
      } else {
        return _get(_getPrototypeOf(Text.prototype), "getNumberFormatter", this).call(this);
      }
    }
  }, {
    key: "getDateFormatter",
    value: function getDateFormatter() {
      if (this.parent) {
        return this.parent.getDateFormatter();
      } else {
        return _get(_getPrototypeOf(Text.prototype), "getDateFormatter", this).call(this);
      }
    }
  }, {
    key: "getDurationFormatter",
    value: function getDurationFormatter() {
      if (this.parent) {
        return this.parent.getDurationFormatter();
      } else {
        return _get(_getPrototypeOf(Text.prototype), "getDurationFormatter", this).call(this);
      }
    }
  }]);
  return Text;
}(Sprite);
Object.defineProperty(Text, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Text"
});
Object.defineProperty(Text, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Sprite.classNames.concat([Text.className])
});